// extracted by mini-css-extract-plugin
module.exports = {"form":"EventForm_form__3YMYN","periodName":"EventForm_periodName__2E1un"};